import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useCallback, useContext } from 'react';
import { getTranslations } from './DesignSystemI18nProvider.config';
import { defaultLanguage } from './DesignSystemI18nProvider.constants';
const DesignSystemI18nContext = React.createContext({
  value: defaultLanguage,
  amountFormatValue: defaultLanguage
});
export function useLanguage() {
  return useContext(DesignSystemI18nContext).value;
}
export function useAmountFormatLanguage() {
  return useContext(DesignSystemI18nContext).amountFormatValue;
}
export function useTranslations() {
  const language = useLanguage();
  const translate = useCallback((translationKey, parameters) => {
    const translation = getTranslations(language)[translationKey];
    if (process.env.NODE_ENV !== 'production' && !translation) {
      console.error(`[useTranslations] Missing translation for key ${translationKey}. This error may occur if you haven't added translations to configuration or misspelled the key name.`);
    }
    if (typeof translation === 'function') {
      return translation(parameters);
    }
    return translation;
  }, [language]);
  return translate;
}
export function withLanguage(Component) {
  return function WrappedComponent(props) {
    const language = useLanguage();
    return React.createElement(Component, _extends({}, props, {
      language: language,
      "data-component": "WrappedComponent"
    }));
  };
}
export function withTranslations(Component) {
  return function WrappedComponent(props) {
    const translate = useTranslations();
    return React.createElement(Component, _extends({}, props, {
      translate: translate,
      "data-component": "WrappedComponent"
    }));
  };
}
export function DesignSystemI18nProvider(_ref) {
  let {
    value,
    amountFormatValue = value,
    children
  } = _ref;
  return React.createElement(DesignSystemI18nContext.Provider, {
    value: {
      value,
      amountFormatValue
    }
  }, children);
}
export const DesignSystemI18nConsumer = DesignSystemI18nContext.Consumer;